export const environment = {
    production: true,
    api: 'https://dev.api.classichub.co.nz',
    buildVersion: '2026.11.5.2',
    uri: 'https://dev.classichub.co.nz',
    envName: 'dev',
    isTest: true,
};

